import Api from '../helpers/api';

export function getGuideTypes() {
	return Api.get('/guide-types');
}
